<template>
	<div>
		<div id="non-printable">
			<v-toolbar flat fixed>
			    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

			    <v-toolbar-title class="white--text">{{$route.query.groupType}}</v-toolbar-title>

			    <v-spacer></v-spacer>

			    <v-btn icon @click="fn_new"><v-icon>add</v-icon></v-btn>

			    <v-text-field elevation-10 flat solo placeholder="Search..." v-model="searchValue" @input="fn_searchItem" slot="extension"></v-text-field>
			</v-toolbar>

			<div class="hasToolbar hasExtension grey-back" :class="{'hasFooter':listItemObject.totalCount}" v-scroll="onScroll">

				<!-- <div class="padding-all-16 light-opacity-color center-align white-background" v-if="!listItemObject.totalCount">There are no {{$route.query.groupType == 'Customer' ? 'customers' : 'suppliers'}}!</div> -->

				<v-list grey-back nopadding style="clear:both" v-if="listItemObject.totalCount">

					<v-subheader white-background subheader-dense>
						Count {{$root.numberToLocale(listItemObject.totalCount)}}
						<v-spacer></v-spacer>

						<div class="font11 mr-2" style="padding-left: 8px;display: flex;align-items: center;border: 1px #ddd solid;border-radius: 5px;" @click="fn_openBrands">
							<div style="max-width: 60px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">Type</div>
							<v-icon>arrow_drop_down</v-icon>
						</div>

						<div class="font11" style="padding-left: 8px;display: flex;align-items: center;border: 1px #ddd solid;border-radius: 5px;" @click="fn_openCompanies">
							<div style="max-width: 60px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{selectionItems.companyName ? selectionItems.companyName : 'Group'}}</div>
							<v-icon>arrow_drop_down</v-icon>
						</div>
					</v-subheader>

					<v-divider></v-divider>

					<div white-background v-for="(item, index) in listItemObject.items" :key="index" :class="{'margin-top-ten':index!=0}" :id="'item_'+item.partyId">

						<v-layout row wrap pt-2 pb-2 pr-3 pl-3 v-ripple @click="fn_itemClick(item.partyId, null, index)">
							<v-flex font16 xs12 sm12 md12>{{item.partyName}}</v-flex>
							<v-flex xs4 sm4 md4 pt-2 light-opacity-color>
								{{item.groupTypeId == 101 ? 'Customer' : item.groupTypeId == 102 ? 'Supplier' : ''}}
							</v-flex>
							<v-flex xs8 sm8 md8 right-align pt-2 font16>
								<div>
						    		&#8377; {{$root.numberToLocale(roundUpto2Decimals(item.amount))}}
						    		<v-icon font20 class="greencolor" v-if="item.balance > 0">arrow_downward</v-icon>
						    		<v-icon font20 class="redcolor" v-if="item.balance < 0">arrow_upward</v-icon>
						    	</div>
							</v-flex>
						</v-layout>


						<v-divider></v-divider>
						<div right-align style="padding:2px 6px">
							<v-btn nomargin icon flat @click="fn_paymentReminder(item)" v-if="item.balance > 0"><v-icon font20>notifications_none</v-icon></v-btn>
							<v-btn nomargin icon flat @click="fn_itemClick(item.partyId, 1, index)">
								<img style="width:20px;opacity:0.6" src="../../../../assets/icon_pdf_light.svg"></img>
							</v-btn>
					    </div>
					</div>

				</v-list>

				<transition name="fade" mode="out-in">
					<v-card noshadow v-if="showPlaceHolder && !listItemObject.totalCount" style="height: calc(100vh - 104px);display: flex;align-items: center;">
						<v-card-text>

							<div center-align>
				            	<div @click="fn_new" v-ripple style="width: 68px;height: 68px;border-radius: 50%;background: #F0F0F0;margin: auto;padding: 12px;position:relative">
				            		<i aria-hidden="true" class="v-icon material-icons" style="position: absolute;top: 0;right: 0px;background: #4b77be !important;border-radius: 50%;color: #fff !important;font-size: 20px;">add</i>
				            		<v-icon style="font-size:42px">person_outline</v-icon>
				            	</div><br>

				            	<p class="title light-opacity-color" style="line-height:28px !important">Add your first {{$route.query.groupType}}</p>
				            </div>

						</v-card-text>
					</v-card>
				</transition>

			</div>	
		</div>

		<v-footer white-background class="pl-3 pr-3" fixed style="border-top:0.5px #F0F0F0 solid;height:auto" v-if="listItemObject.totalCount">
			<v-layout wrap align-center>
	    	  	<v-flex light-opacity-color xs4 style="text-align:left">{{fn_getTotalLabel()}}</v-flex>
	    	  	<v-flex xs8 style="text-align:right">
	    	  		<span v-if="listItemObject.totalReceivables">&#8377; {{$root.numberToLocale(roundUpto2Decimals(listItemObject.totalReceivables))}}</span>

	    	  		<span v-else-if="listItemObject.totalPayables">&#8377; {{$root.numberToLocale(roundUpto2Decimals(listItemObject.totalPayables))}}</span>
	    	  		
	    	  		<span v-else>&#8377; 0</span>

	    	  		<span v-if="listItemObject.totalReceivables || listItemObject.totalPayables">
	    	  			<v-icon font18 :class="[listItemObject.totalReceivables ? 'greencolor' : 'redcolor']">{{listItemObject.totalReceivables ? 'arrow_downward' : 'arrow_upward'}}</v-icon>
	    	  		</span>
	    	  </v-flex>
	    	</v-layout>
	    </v-footer>

		<!-- <canvas id="canvas-due-tab" width="400" height="200" class="payment-reminder-canvas" style="max-width:100%"></canvas> -->

		<!-- <dialog-filter-items ref="ref_dialogFilterItems" title="Filter By" :filterData="filterData" :setFilter="fn_setFilter" :selectedFilterItemId="selectedFilterItemId" :selectedSortValue="selectedSortValue"></dialog-filter-items>

		<dialog-transaction-options ref="ref_dialogTransactionOptions" :groupTypeId="selectedItemObj.groupTypeId" :accountId="selectedItemObj.partyId" :accountName="selectedItemObj.partyName" v-if="selectedItemObj"></dialog-transaction-options>

		<canvas id="canvas-due-tab" width="400" height="200" class="payment-reminder-canvas" style="max-width:100%"></canvas> -->
	</div>
</template>

<script>
const transactionTypes = require('../../../../config.js').configs.transactionTypes;

// const transactionForms = require('../../../../config.js').configs.transactionForms;

// const dialogjs =  require('../../../masters/forms/dialog').dialogjs;
// const listIdObject = require('../../../../config.js').configs.mastersPredefinedLists;

	export default{
		name:"ledger_items",
		data(){
			return{
				listItemObject:{"items":[], "totalCount":0, "totalReceivables":0, "totalPayables":0},
				searchValue:'',
				startIndex:0,
				loadMore:false,
				routeChange:false,
				showPlaceHolder:false
			}
		},
		methods:{

			fn_getTotalLabel: function(){
				if(this.listItemObject.totalReceivables || (!this.listItemObject.totalPayables && this.$route.query.groupType == "Customer")){
					return "To Receive";
				}
				else{
					return "To Pay";
				}
			},

			onScroll: function(event){
				var element = event.target;
			    if (element.documentElement.scrollHeight - element.documentElement.scrollTop - 20 <= element.documentElement.clientHeight)
			    {
			        console.log('scrolled');
			        if(this.listItemObject.items.length < this.listItemObject.totalCount && !this.routeChange){
			        	this.fn_loadItems();
			        }
			    }
			},

			fn_paymentReminder: function(item){
				let self = this;
				this.$root.fn_checkStoragePermission(function(){
                    let obj = {};
					obj.amount = item.amount;
					obj.primaryMobileNumber = item.primaryMobileNumber;
					obj.email = item.email;
					self.$root.fn_sendPaymentReminder(obj, "canvas-due-tab");
                });
			},

			fn_new: function(){
				let obj = {};
				obj.itemId = null;
				obj.type = this.$route.query.groupType;
				obj.lastScrollPos = window.pageYOffset;
				obj.itemIndex = this.listItemObject.items.length;
				localStorage.setItem("ledgers_items_state",JSON.stringify(obj));

				this.routeChange = true;

				let groupTypeId = this.$route.query.groupType == "Customer" ? 101 : 102;
				this.$router.push({path:'/masters/accounts/ledgers/items/new', query:{tagId:this.guidWeb(), routeToDisplay:true, groupTypeId:groupTypeId}});
				// this.$router.push('/settings');
			},

			fn_itemClick: function (itemId, shareStatement, index) {
				let obj = {};
				obj.itemId = null;
				obj.type = this.$route.query.groupType;
				obj.lastScrollPos = window.pageYOffset;
				obj.itemIndex = index + 1;
				localStorage.setItem("ledgers_items_state",JSON.stringify(obj));

				this.routeChange = true;

				if(shareStatement){
					this.$router.push({path:'/masters/accounts/ledgers/items/'+itemId, query:{statementType:1}});
				}
				else{
					this.$router.push('/masters/accounts/ledgers/items/'+itemId);
				}
			},

			fn_loadItems: function() {
				this.loadMore = true;
		    	let filterObject = {};
				filterObject.limit = 50;
				filterObject.startIndex = this.startIndex;
				filterObject.search = this.searchValue ? this.searchValue.toLowerCase() : '';
				filterObject.groupTypeId = this.$route.query.groupType == "Customer" ? 101 : 102;
				// filterObject.sortByAmount = this.selectedSortValue;

				let pageState = null;
				if(localStorage.getItem("ledgers_items_state")){
					pageState = JSON.parse(localStorage.getItem("ledgers_items_state"));
					filterObject.limit = 50 - (pageState.itemIndex % 50) + pageState.itemIndex;
				}

				console.log(filterObject.limit);

				let self = this;
				this.getItems("LedgerItems", filterObject, 
					{
						onSuccess: function (response) {
							console.log(response);
							let responseJson = JSON.parse(response);
							self.listItemObject.totalCount = responseJson.totalCount;
							self.listItemObject.totalReceivables = responseJson.totalReceivables ? responseJson.totalReceivables : 0;
							self.listItemObject.totalPayables = responseJson.totalPayables ? responseJson.totalPayables : 0;

							for(let i in responseJson.items){
								let itemIndex = self.listItemObject.items.findIndex(item => item.partyId==responseJson.items[i].partyId);

								if(itemIndex==-1){
									self.listItemObject.items.push(responseJson.items[i]);	
								}
								// self.listItemObject.items.push(responseJson.items[i]);
							}

							console.log(pageState);
							if(pageState && pageState.itemId){
								setTimeout(function(){
									// self.$vuetify.goTo('#item_'+pageState.itemId, self.scrollOptions);
									let scrollOptions = {"duration":0, "offset":-104, "easing":"linear"};
									self.$vuetify.goTo('#item_'+pageState.itemId, scrollOptions);
									localStorage.removeItem("ledgers_items_state");
								},100);
							}

							self.startIndex = self.listItemObject.items.length;
							self.loadMore = false;

							setTimeout(function(){
								self.showPlaceHolder = true;
							},300)
						},
						onError: function (error) {
							console.log(error);
							// self.loadMore = false;
						}
					}
				)
		    },

		    fn_searchItem: function () {
				this.startIndex = 0;
				this.listItemObject.items = [];
				this.fn_loadItems();
			},

			fn_goBack: function(){
				this.$router.go(-1);
			},

			fn_showWebView: function () {
				var viewObject = {};
				viewObject.ToolbarTitle = "Ledger";

				var tagId = null
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			}

			
		},
		mounted: function(){
			// console.log(this.$route);
			// window.js_globals.fn_onBackPress = this.fn_goBack;
			// this.fn_showWebView();
			// this.fn_searchItem();
			console.log(this.$route);
			window.js_globals.fn_onBackPress = this.fn_goBack;
			this.fn_showWebView();
			if(this.$route.params.isNew){
				localStorage.removeItem("ledgers_items_state");
			}
			this.routeChange = false;
			this.fn_searchItem();
		},
		// activated: function(){
		// 	console.log(this.$route);
		// 	window.js_globals.fn_onBackPress = this.fn_goBack;
		// 	this.fn_showWebView();
		// 	if(this.$route.params.isNew){
		// 		localStorage.removeItem("ledgers_items_state");
		// 	}
		// 	this.routeChange = false;
		// 	this.fn_searchItem();
		// },
	}
</script>


// WEBPACK FOOTER //
// src/components/masters/forms/ledgers/items_web.vue